exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown-menu[data-v-3f6acfb8]{position:absolute !important;transform:translate3d(28px, 46px, 0px) !important;top:0px !important;left:0px !important;will-change:transform\n}", ""]);

// exports
